<template>
  <div class="confirmation">
    <div class="content" :class="{ 'rounded-page container': !isMobile }">
      <div class="image-column column">
        <figure v-if="isMobile" />
        <figure v-else />
      </div>
      <div class="column text-column">
        <p class="container intro text-left">
          <span class="bold">Great - you're all set!</span>
        </p>
        <template v-if="scheduled">
          <p class="container scheduled-date text-left">
            Your call is confirmed for<br>
            <span
              class="bold call-date"
            >{{ formattedDate }} at {{ formattedTimeSuffixed }}</span>
          </p>
        </template>
        <template v-else>
          <p class="container call-now text-left">
            We're just reviewing your details and will call in a few minutes.<br>
            <span
              class="call-now--subtitle"
            >Your expert will be calling from an 0800 number</span>
          </p>
        </template>
        <div class="container what-to-expect">
          <p>What should I expect on the call?</p>
          <slot name="callItems" />
        </div>
      </div>
    </div>
    <hr>
    <div class="footer" :class="{ container: !isMobile }">
      <div class="footer-scheduled-content">
        <img src="@/assets/icons/orange-tilt-phone.svg" alt="Phone icon">
        <div>
          <span>If you want to speak to our experts sooner, just call</span>
          <span
            class="bold"
          ><a :href="'tel:' + micPhoneNumber">
            {{ micPhoneNumberFormatted }}</a></span>
        </div>
      </div>
    </div>
    <Popup />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Popup from '../confirmation/Popup'

export default {
  name: 'CDCConfirmationPage',
  components: {
    Popup
  },
  props: {
    useConfirmationLogo: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      CallBack: (state) => state.CallBack,
      micPhoneNumber: (state) => state.Campaign.micPhoneNumber
    }),
    ...mapGetters([
      'isMobile',
      'formattedDate',
      'formattedTimeSuffixed',
      'micPhoneNumberFormatted'
    ]),
    scheduled () {
      return !!this.CallBack.contactDateTime
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-flow: row wrap;
  flex-direction: column;
  padding-top: $callback-padding-top;

  .intro {
    font-size: 40px;
    line-height: 51px;
    margin-bottom: 23px;
    font-family: $font-family-bold;
    color: $bionic-orange;

    @media (max-width: $screen-md) {
      font-size: 25px;
      line-height: 30px;
      margin-bottom: $spacing-16;
    }
  }

  .image-column {
    @media(min-width: $screen-md) {
      max-width: 390px;
      height: 390px;
    }
  }

  .call-now {
    font-size: 17px;
    letter-spacing: 0;
    line-height: 30px;
    color: $black;
    margin-bottom: 37px;

    @media (min-width: $screen-md) {
      font-size: 24px;
      line-height: 30px;
      max-width: 420px;
      margin: 0;
      padding-right: 0;
    }

    &--subtitle {
      font-size: 12px;
      line-height: 15px;

      @media (min-width: $screen-md) {
        font-size: 14px;
        line-height: 17px;
      }
    }
  }

  .scheduled-date {
    font-size: 32px;
    color: $callback-schedule-text;
    line-height: 40px;

    @media (max-width: $screen-sm) {
      font-size: 20px;
    }
  }

  .scheduled-time {
    font-size: 70px;
    line-height: 70px;
    color: $callback-schedule-text;
    margin-bottom: $spacing-40;

    @media (max-width: $screen-md) {
      margin-bottom: $spacing-12;
    }

    @media (max-width: $screen-sm) {
      font-size: 40px;
    }
  }

  .column {
    flex: 1;
    padding-top: $spacing-12;
  }

  figure {
    margin: $callback-image-margin;
    background-position: center;
    background-size: cover;
    background-image: url("../assets/images/ctm-call-schedule.png");
    max-width: 100vw;
    width: $callback-image-width;
    height: 50vw;

    @media (min-width: $screen-md) {
      height: $cdc-callback-image-dimension;
      width: $cdc-callback-image-dimension;
      margin-left: $spacing-48;
      margin-bottom: $spacing-12;
      width: 390px;
      height: 390px;
      float: right;
    }
  }

  @media (min-width: $screen-md) {
    .what-to-expect,
    .intro {
      max-width: 592px;
      margin-right: $spacing-0;
      margin-left: $spacing-0;
    }
  }

  .what-to-expect {
    @media (min-width: $screen-md) {
      margin-top: 52px;
    }

    > p {
      font-size: 20px;
      line-height: 30px;
      text-align: left;
      padding-left: $spacing-0;
      color: $bionic-blue;

      @media (max-width: $screen-md) {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .items {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      margin-bottom: 19px;
      padding-left: 0;

      @media (max-width: $screen-md) {
        margin-bottom: $spacing-24;
      }

      .bullet {
        &-point {
            line-height: 34px;
            width: 34px;
            min-width: 34px;
            font-size: 21px;
          color: $white;
          background-color: $callback-bullet-bg;
          border-radius: 50%;
          text-align: center;
          font-weight: bold;

          @media (max-width: $screen-md) {
            margin-left: $spacing-0;
          }

          @media (max-width: $screen-sm) {
            line-height: 34px;
            width: 34px;
            min-width: 34px;
            font-size: 21px;
          }
        }

        &-item {
          font-size: 14px;
          text-align: left;
          margin-left: $spacing-12;
          padding-left: 0;
          color: $black;
          line-height: 22px;

          @media (max-width: $screen-md) {
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
}

.footer {
  bottom: 0;
  width: 100%;
  background-color: $callback-bg;
  min-height: 33px;
  z-index: 999;

  @media (max-width: $screen-md) {
    min-height: 26px;
  }

  .footer-scheduled-content {
    padding: $spacing-12 $spacing-32;
    padding-left: 0;
    font-size: 24px;
    color: $bionic-navy;
    display: flex;
    align-items: center;

    @media (max-width: $screen-md) {
      font-size: 14px;
      text-align: left;
      padding: $spacing-12 $spacing-16 $spacing-18;
    }

    img {
      height: 21px;
      margin-right: 14px;
    }
  }
  .footer-unscheduled-content {
    font-size: 16px;
    position: absolute;
    bottom: $spacing-12;
    z-index: 999;
    text-align: center;
    width: 100%;

    @media (min-width: $screen-md) {
      position: relative;
      left: 50%;
      width: 50%;
      bottom: 34px;
      background-color: $white;
      text-align: left;
      padding: $spacing-16;
      margin: -$spacing-24 $spacing-0;
    }
  }
}

.bold {
  font-weight: $bold-font-weight;
}

.call-date {
  @media (max-width: $screen-md) {
    display: block;
  }
}

.rounded-page {
  position: relative;
  z-index: 100;
  background-color: $page-bg;
  overflow: hidden;
  flex-grow: 1;
  margin-top: -$spacing-16;
  border-radius: $border-radius-large $border-radius-large 0 0;
  display: flex;
  flex-direction: column;

  @media (min-width: 800px) {
    flex-direction: row-reverse;
    margin-top: 44px;
  }

  @media (max-width: $screen-md) {
    margin-top: -$spacing-8;
    border-radius: $border-radius-medium $border-radius-medium 0 0;
  }
}

.logo {
  max-width: 180px;
  width: 100%;
}
</style>
